import { render } from "./company-sites.vue?vue&type=template&id=21088a1d&ts=true"
import script from "./company-sites.vue?vue&type=script&lang=ts"
export * from "./company-sites.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__